export default [
  {
    path: '/patreon',
    name: 'Patreon',
    component: () => import('@/modules/Patreon/PatreonPage.vue'),
  },
]
